import emailIcon from "../../../assets/icons/contact_icons/email-icon.png";
import emailIconViolet from "../../../assets/icons/contact_icons/email-icon_mariposa_violet.png";
import phoneIcon from "../../../assets/icons/contact_icons/phone-icon.png";
import phoneIconViolet from "../../../assets/icons/contact_icons/phone-icon_mariposa_violet.png";
import facebookIcon from "../../../assets/icons/contact_icons/facebook-icon.png";
import facebookIconViolet from "../../../assets/icons/contact_icons/facebook-icon_mariposa_violet.png";
import instagramIcon from "../../../assets/icons/contact_icons/instagram-icon.png";
import instagramIconViolet from "../../../assets/icons/contact_icons/instagram-icon_mariposa_violet.png";
import {Link} from "react-router-dom";


const QuickLinks = () => {

    return (
        <div className={"quick-links"}>
            <Link to={"mailto:mariposabij@gmail.com"}>
                <img className={"link-default"}
                     alt={"tel:+1 237 267 1349"}
                     src={emailIcon}
                     height={25}
                     onMouseOver={e => (e.currentTarget.src = emailIconViolet)}
                     onMouseOut={e => (e.currentTarget.src = emailIcon)}/>
            </Link>
            <Link to={"tel:+33 7 82 45 29 37"}>
                <img className={"link-default"}
                     alt={"tel:+1 237 267 1349"}
                     src={phoneIcon}
                     height={25}
                     onMouseOver={e => (e.currentTarget.src = phoneIconViolet)}
                     onMouseOut={e => (e.currentTarget.src = phoneIcon)}/>
            </Link>
            <Link to={"https://www.facebook.com/profile.php?id=100071174686041"}
                  target={"_blank"} rel={"noopener noreferrer"}>
                <img className={"link-default"}
                     alt={"goto:https://www.facebook.com/profile.php?id=100071174686041"}
                     src={facebookIcon}
                     height={25}
                     onMouseOver={e => (e.currentTarget.src = facebookIconViolet)}
                     onMouseOut={e => (e.currentTarget.src = facebookIcon)}/>
            </Link>
            <Link to={"https://www.instagram.com/mariposabijouxjewelry"}
                  target={"_blank"} rel={"noopener noreferrer"}>
                <img className={"link-default"}
                     alt={"goto:https://www.instagram.com/mariposabijouxjewelry"} src={instagramIcon}
                     onMouseOver={e => (e.currentTarget.src = instagramIconViolet)}
                     onMouseOut={e => (e.currentTarget.src = instagramIcon)}
                     height={25}/>
            </Link>
        </div>
    );
};

export default QuickLinks;
